import { WizardContext } from "../types/WizardContext";

export const ComputeChannelAverage = {
	name: "ComputeChannelAverage",
	description:"Computes the value average of a numerical data channel.",
	parameters: {
		channel: {
			type:"string",
			drawer(context:WizardContext){
				const options = 
				context.channels
				.filter(canAverageChannel)
				.map((channel) => {
					return {
						text: channel.name,
						value: channel.key,
						group: channel.group,
						groupName: channel.groupName
					};
				});

				return {
					type:"dropdown",
					options
				}
			},
			default:null
		}
	},
	output:{
		avg:{
			type:"number"
		}
	}
};

const canAverageChannel = (c:any) => {
	if(c.value !== "number"){ return false; }
	return [
		"form/linearscale/row",
		"gallery/feedback/scale",
	].findIndex(t => t === c.type) > -1;
};